"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRouteParams = void 0;
var react_router_1 = require("react-router");
/* eslint-disable-file @typescript-eslint/no-unused-vars */
var useRouteParams = function () {
    return (0, react_router_1.useParams)();
};
exports.useRouteParams = useRouteParams;
